module.exports = __webpack_public_path__ + "static/media/basic@2x.95092eef.png";